import React, { useState } from "react";
import sms_check from "../../../../assets/images/sms_check.svg";
import Logo_b from "../../../../assets/images/Logo_b.svg";
import call_2 from "../../../../assets/images/call_2.svg";
import sms_2 from "../../../../assets/images/sms_2.svg";
import location_1 from "../../../../assets/images/location_1.svg";
import lolo_fb from "../../../../assets/images/lolo_fb.svg";
import lolo_you from "../../../../assets/images/lolo_you.svg";
import lolo_tik from "../../../../assets/images/lolo_tik.svg";


import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Divider } from "@mui/material";
import { FaChevronRight } from "react-icons/fa6";

export default function Footer() {
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Vui lòng nhập email!");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Email không hợp lệ!");
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      toast.success("Gửi email thành công!");
      setEmail("");
    }, 2000);
  };
  return (
    <div className="w-full text-white lg:pb-6 bg-center bg-cover bg-no-repeat bg-[url('./assets/images/footer_mo.webp')] md:bg-[url('./assets/images/footer_pc.webp')]">
      <div className="flex flex-col lg:flex-row w-full gap-4 lg:items-center container mx-auto p-3 lg:justify-between pt-4">
        <div className="flex flex-col gap-4 max-w-lg">
          <p className="font-semibold text-xl md:text-2xl text-white">Bản tin</p>
          <p className="text-sm md:text-base text-white font-normal">
            Đăng ký nhận bản tin hàng tuần của BlueSkyIT để nhận được những
            thông tin cập nhật mới nhất.
          </p>
        </div>
        <div>
          <div className="flex items-center justify-between bg-white rounded-full p-2 shadow-lg w-full max-w-md lg:max-w-lg">
            <div className="flex items-center space-x-2 px-4 flex-1 min-w-0">
              <img src={sms_check} alt="sms_check" className="w-5 h-5 flex-shrink-0" />
              <input
                type="email"
                placeholder="Nhập email của bạn"
                value={email}
                onChange={handleEmailChange}
                className="outline-none text-black text-sm w-full min-w-0"
              />
            </div>
            <button
              onClick={handleSubmit}
              className="bg-[#27C6FF] text-white flex items-center justify-center px-6 py-2 h-11 rounded-full whitespace-nowrap flex-shrink-0"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="animate-spin h-5 w-5 border-4 border-t-4 border-white border-solid rounded-full" />
              ) : (
                "Gửi"
              )}
            </button>
          </div>

          <ToastContainer />
        </div>
      </div>
      <div className="container mx-auto border-b-white p-3 w-full text-white">
        <Divider sx={{ borderBottom: "1px solid white" }} />
      </div>

      <div className="container mx-auto p-3 grid grid-cols-1 lg:grid-cols-3 w-full gap-6">
        <div className="flex flex-col gap-4 w-full">
          <div>
            <img src={Logo_b} alt="lo" />
          </div>
          <div className="flex flex-col">
            <p>Công ty cổ phần đầu tư & công nghệ</p>
            <p>
              Bầu Trời Xanh - Cung cấp mọi giải pháp công nghệ hàng đầu tại Việt
              Nam
            </p>
          </div>
          <div className="flex flex-col gap-2 lg:gap-4">
            <div>
              <p className="text-[1.25rem] font-semibold">Mạng xã hội</p>
            </div>
            <div className="flex items-center gap-3">
              <div className=" bg-white border border-white w-10 h-10 flex items-center justify-center rounded-full">
                <img src={lolo_fb} alt="fbb" />
              </div>
              <div className=" bg-white border border-white w-10 h-10 flex items-center justify-center rounded-full">
                <img src={lolo_you} alt="fbb" />
              </div>
              <div className=" bg-white border border-white w-10 h-10 flex items-center justify-center rounded-full">
                <img src={lolo_tik} alt="fbb" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <p className="text-[24px] font-semibold">Thông tin liên hệ</p>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-10 h-10 bg-[#27C6FF] rounded-full">
              <img src={call_2} alt="cal" />
            </div>
            <div>
              <p>0968.596.859</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-10 h-10 bg-[#27C6FF] rounded-full">
              <img src={sms_2} alt="sms" />
            </div>
            <div>
              <p>lienhe@blueskyit.vn</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-12 lg:w-10 h-10 bg-[#27C6FF] rounded-full">
              <img src={location_1} alt="map_mobi" />
            </div>
            <div>
              <p className="lg:w-[18rem]">
                BT16B6 -32, Làng Việt Kiều Châu Âu, Mỗ Lao, Hà Đông, Hà Nội
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div>
            <p className="text-[24px] font-semibold">Đường dẫn</p>
            <ul className=" flex flex-col lg:gap-3 gap-3 lg:mt-3">
              <li className="flex items-center gap-1 lg:-ml-10 -ml-10">
                <FaChevronRight />
                Trang chủ
              </li>
              <li className="flex items-center gap-1 lg:-ml-10 -ml-10">
                <FaChevronRight />
                Về chúng tôi
              </li>
              <li className="flex items-center gap-1 lg:-ml-10 -ml-10">
                <FaChevronRight />
                Sản phẩm
              </li>
              <li className="flex items-center gap-1 lg:-ml-10 -ml-10">
                <FaChevronRight />
                Tin tức
              </li>
              <li className="flex items-center gap-1 lg:-ml-10 -ml-10">
                <FaChevronRight />
                Liên hệ
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container mx-auto border-b-white p-3 w-full text-white">
        <Divider sx={{ borderBottom: "1px solid white" }} />
      </div>

      <div className="w-full  text-[#1375B7] container p-3  relative lg:rounded-[40px] lg:mx-auto rounded  lg:flex-row lg:items-center lg:justify-between  flex flex-col items-center justify-center gap-4">
        <div className="flex flex-wrap items-center w-full gap-4 sm:gap-6 text-white text-sm md:text-base">
          <Link
            to="/chinh-sach-bao-mat"
            className="hover:underline underline-offset-4"
          >
            Chính sách bảo mật
          </Link>
          <Link
            to="/dieu-khoan-su-dung"
            className="hover:underline underline-offset-4"
          >
            Điều khoản sử dụng
          </Link>
          <Link
            to="/dieu-khoan-tai-app"
            className="hover:underline underline-offset-4"
          >
            Điều khoản tải app
          </Link>
        </div>
        <div>
          <p className="lg:whitespace-nowrap text-white">
            Copyright © 2024 BlueSkyIT. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
